import { StatusCodes } from 'http-status-codes';

// const responseStatus = {
//   OK: StatusCodes.OK,
//   CREATED: StatusCodes.CREATED,
//   BAD_REQUEST: StatusCodes.BAD_REQUEST,
//   UNAUTHORIZED: StatusCodes.UNAUTHORIZED,
//   FORBIDDEN: StatusCodes.FORBIDDEN,
//   NOT_FOUND: StatusCodes.NOT_FOUND,
//   INTERNAL_SERVER_ERROR: StatusCodes.INTERNAL_SERVER_ERROR,
// };

export const generateFileUploadErrorResponse = (
  statusCode: unknown,
  name: string = '',
): string => {
  let errorMessage = '';

  if (statusCode === StatusCodes.NOT_FOUND) {
    errorMessage = `Upload error: Files not found on your company ${name}`;
  } else if (statusCode === StatusCodes.BAD_REQUEST) {
    errorMessage = `Upload error: Failure to process request ${name}`;
  } else if (statusCode === StatusCodes.UNAUTHORIZED) {
    errorMessage = `Upload error: You are unauthorized to upload files ${name}`;
  } else if (statusCode === StatusCodes.FORBIDDEN) {
    errorMessage = `Upload error: You cannot use this request ${name}`;
  } else if (statusCode === StatusCodes.INTERNAL_SERVER_ERROR) {
    errorMessage = `Upload error: Error happened in the server ${name}`;
  } else {
    errorMessage = 'An error occurred during the upload';
  }

  return errorMessage;
};

export const generateFileUploadToS3BucketErrorResponse = (
  statusCode: unknown,
  name: string = '',
): string => {
  let errorMessage = '';

  if (statusCode === StatusCodes.NOT_FOUND) {
    errorMessage = `Uploading files not found on AWS S3 ${name}.`;
  } else if (statusCode === StatusCodes.BAD_REQUEST) {
    errorMessage = `Failure to process request on AWS S3 ${name}.`;
  } else if (statusCode === StatusCodes.UNAUTHORIZED) {
    errorMessage = `You are unauthorized to upload files on AWS S3 ${name}.`;
  } else if (statusCode === StatusCodes.FORBIDDEN) {
    errorMessage = `You cannot use this request on AWS S3 ${name}.`;
  } else if (statusCode === StatusCodes.INTERNAL_SERVER_ERROR) {
    errorMessage = `Error happened in the server on AWS S3 ${name}.`;
  }

  return errorMessage;
};

export const generateReportSubmissionErrorResponse = (
  statusCode: unknown,
  name: string = '',
): string => {
  let errorMessage = '';

  if (statusCode === StatusCodes.NOT_FOUND) {
    errorMessage = `Submission error: Resource not found on your company ${name}`;
  } else if (statusCode === StatusCodes.BAD_REQUEST) {
    errorMessage = `Submission error: Failure to process request ${name}`;
  } else if (statusCode === StatusCodes.UNAUTHORIZED) {
    errorMessage = `Submission error: You are unauthorized to submit reports ${name}`;
  } else if (statusCode === StatusCodes.FORBIDDEN) {
    errorMessage = `Submission error: You cannot use this request ${name}`;
  } else if (statusCode === StatusCodes.INTERNAL_SERVER_ERROR) {
    errorMessage = `Submission error: Error happened in the server ${name}`;
  } else {
    errorMessage = 'An error occurred during report submission';
  }

  return errorMessage;
};

export const generateFetchReportErrorResponse = (
  statusCode: unknown,
): string => {
  let errorMessage = '';

  if (statusCode === StatusCodes.NOT_FOUND) {
    errorMessage = 'Report(s) not found for your company';
  } else if (statusCode === StatusCodes.INTERNAL_SERVER_ERROR) {
    errorMessage = 'Error happened in the server';
  } else {
    errorMessage = 'Error fetching report';
  }

  return errorMessage;
};

export const generateFetchReportTypeErrorResponse = (
  statusCode: unknown,
): string => {
  let errorMessage = '';

  if (statusCode === StatusCodes.NOT_FOUND) {
    errorMessage = 'ReportProps types are not found in your company';
  } else if (statusCode === StatusCodes.INTERNAL_SERVER_ERROR) {
    errorMessage = 'Error happened in the server';
  } else {
    errorMessage = 'Error fetching report types';
  }

  return errorMessage;
};
